@if (count() > 0) {
	<div class="counter">{{ count() }}</div>
}
